import { render, staticRenderFns } from "./ScreenLaudoPessario.vue?vue&type=template&id=0486318a&lang=true&"
import script from "./ScreenLaudoPessario.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoPessario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports